import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { Tilt } from 'entities/Tilt';

export const tiltApi = createApi({
  reducerPath: 'tiltApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL}`,
    prepareHeaders: (headers) => {
      try {
        const token = localStorage.getItem('token');

        if (token) {
          headers.set('Authorization', `Bearer ${JSON.parse(token)}`);
        }
      } catch (error) {
        console.warn('Error');
      }

      return headers;
    },
  }),
  endpoints: (builder) => ({
    getTiltList: builder.query<{ success: boolean; data: Tilt[] }, void>({
      query: () => {
        return {
          url: '/tilts',
          credentials: 'include',
          mode: 'cors',
        };
      },
    }),
  }),
});

export const { useGetTiltListQuery } = tiltApi;
